module.exports = __webpack_public_path__ + "static/media/screenshot(38).d9883312.jpg";